<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <el-form-item label="时间：" class="form-item-b0">
            <el-date-picker
              v-model="beginDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>
          <el-button size="small" @click="init()">重置</el-button>
        </div>

        <div style="margin-left: 20px; font-size: 36px">
          {{ total }}
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column prop="LoginName" label="手机号" align="center"></el-table-column>

      <el-table-column prop="Date" align="center" label="一周总访问">
        <template slot-scope="scope">{{ scope.row.allCount }}</template>
      </el-table-column>

      <el-table-column
        prop="Date"
        align="center"
        v-for="(item, index) in tableLabels"
        :key="index"
        :label="new Date(item) | parseTime(`{y}-{m}-{d}\n星期{a}`)"
      >
        <template slot-scope="scope">{{ scope.row[item] ? scope.row[item].LogCount : 0 }}</template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h5Jump',
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      list: [],
      total: 0,

      loading: true,

      beginDate: [
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 6, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      ],

      query: {
        pageindex: 1,
        pagesize: 40,
        search: '编辑报价单',
        beginTime: '',
        endTime: ''
      },

      tableLabels: [
        this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 1, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 2, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 3, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 4, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 5, '{y}-{m}-{d}'),
        this.$globalFun.parseTime(new Date() - 24 * 60 * 60 * 1000 * 6, '{y}-{m}-{d}')
      ]
    }
  },

  created() {
    this.init()
  },

  computed: {},

  methods: {
    // 初始化
    init() {
      this.query.search = '编辑报价单'

      this.getList('place')
    },

    // 获取列表
    async getList(place, day) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        this.$nextTick(() => {
          this.$refs.TableListRef.bodyWrapper.scrollTop = 0
        })
      }

      if (!this.beginDate || !this.beginDate.length) {
        this.query.beginTime = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
        this.query.endTime = this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}')
      } else {
        this.query.beginTime = this.beginDate[0]
        this.query.endTime = this.beginDate[1]
      }
      console.log(this.query)

      const { data: res } = await this.$api.user.h5Jump(this.query)
      console.log('获取列表', res)

      this.list = this.setList(res.list)
      this.total = res.count
      this.loading = false
    },

    setList(list) {
      const dataObj = {}

      list.forEach((item) => {
        const date = this.$globalFun.parseTime(new Date(item.Date), '{y}-{m}-{d}')

        if (dataObj[item.LoginName]) {
          console.log(dataObj[item.LoginName])
          dataObj[item.LoginName].allCount += 1

          if (dataObj[item.LoginName][date]) {
            dataObj[item.LoginName][date].LogCount += 1
          } else {
            dataObj[item.LoginName][date] = {
              LogCount: 1
            }
          }
        } else {
          dataObj[item.LoginName] = {
            LoginName: item.LoginName,
            allCount: 1,
            [date]: {
              LogCount: 1
            }
          }
        }
      })

      const result = Object.values(dataObj)
      console.log('处理后的数据', result, dataObj)

      return result
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  font-size: 12px !important;
}
</style>
